var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)",
    fill: "#A277EE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 21.987H3c-.6 0-1-.4-1-1v-7c0-.6.4-1 1-1s1 .4 1 1v6h16v-6c0-.6.4-1 1-1s1 .4 1 1v7c0 .6-.4 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2 5.788l-3.5-3.5c-.1-.1-.2-.2-.3-.2-.2-.1-.5-.1-.8 0-.1.1-.2.1-.3.2l-3.5 3.5c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l1.8-1.8v10.6c0 .6.4 1 1 1s1-.4 1-1v-10.6l1.8 1.8c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.3.4-1 0-1.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.af15f6e3cfd9137ceab7452bd3f3dbf7.svg";
export { ForwardRef as ReactComponent };